export default {
  common: {
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    save: 'Guardar',
    edit: 'Editar',
    delete: 'Eliminar',
    loading: 'Cargando...',
    loadMore: 'Cargar más',
    noMore: 'No hay más',
    retry: 'Reintentar',
    back: 'Volver',
    next: 'Siguiente',
    prev: 'Anterior',
    submit: 'Enviar',
    reset: 'Restablecer',
    search: 'Buscar',
    filter: 'Filtrar',
    sort: 'Ordenar',
    refresh: 'Actualizar',
    complete: 'Completado',
    skip: 'Omitir'
  },
  nav: {
    discover: 'Inicio',
    message: 'Mensajes',
    store: 'Tienda',
    mine: 'Mi',
    recommend: 'Recomendado',
  },
  scene: {
    changeScene: 'Cambiar escena',
    seeAll: 'Ver todo',
    putAway: 'Ocultar',
    selectScene: 'Seleccionar esta escena',
    selected: 'Seleccionado',
    sceneIndex: 'Escena {num}',
  },
  home: {
    title: 'Mundo de Rol',
    subtitle: 'Comienza tu historia',
    startGame: 'Iniciar juego',
    continueGame: 'Continuar',
    newGame: 'Nuevo juego',
    gameLibrary: 'Biblioteca',
    featured: 'Destacado',
    popular: 'Popular',
    recent: 'Reciente',
    searchHistory: 'Historial de búsqueda',
    search: 'Buscar roles...',
    noData: 'Sin datos',
    noMoreData: 'No hay más datos',
    noNetwork: 'Sin red',
    pleaseSelectFilter: 'Por favor seleccione las condiciones de filtro',
  },
  user: {
    login: 'Iniciar sesión',
    register: 'Registrarse',
    logout: 'Cerrar sesión',
    profile: 'Perfil',
    avatar: 'Avatar',
    nickname: 'Apodo',
    email: 'Correo electrónico',
    phone: 'Teléfono',
    password: 'Contraseña',
    confirmPassword: 'Confirmar contraseña',
    oldPassword: 'Contraseña antigua',
    newPassword: 'Nueva contraseña',
    forgotPassword: 'Olvidé mi contraseña',
    changePassword: 'Cambiar contraseña',
    bindPhone: 'Vincular teléfono',
    verifyCode: 'Código de verificación',
    sendCode: 'Enviar código',
    level: 'Nivel',
    experience: 'Experiencia',
    achievement: 'Logro',
    history: 'Historial'
  },
  game: {
    character: 'Personaje',
    story: 'Historia',
    chapter: 'Capítulo',
    scene: 'Escena',
    dialogue: 'Diálogo',
    choice: 'Elección',
    inventory: 'Inventario',
    achievement: 'Logro',
    save: 'Guardar juego',
    load: 'Cargar juego',
    restart: 'Reiniciar',
    pause: 'Pausar',
    resume: 'Reanudar',
    auto: 'Auto',
    speed: 'Velocidad',
    volume: 'Volumen',
    settings: 'Configuración del juego'
  },
  message: {
    success: 'Éxito',
    error: 'Error',
    warning: 'Advertencia',
    info: 'Información',
    networkError: 'Error de red',
    serverError: 'Error del servidor',
    loginSuccess: 'Registro exitoso',
    loginFailed: 'Error en el registro',
    logoutSuccess: 'Sesión cerrada',
    saveSuccess: 'Guardado exitoso',
    saveFailed: 'Error al guardar',
    deleteConfirm: '¿Confirmar eliminación?',
    operationConfirm: '¿Confirmar operación?',
    noNewsYet: 'Aún no hay noticias',
    deleteSuccess: 'Eliminado exitosamente',
    deleteFailed: 'Error al eliminar',
    deleteMessage: '¿Está seguro de que desea eliminar este mensaje? ¡Una vez completado, no se puede deshacer!',
    delete: 'Eliminar',
    deleting: 'Eliminando...',
    noMoreData: 'No hay más mensajes',
    downloading: 'Descargando...',
    downloadSuccess: 'Descarga exitosa',
    downloadFailed: 'Error en la descarga',
    copySuccess: 'Copiado exitosamente',
    copyFailed: 'Error al copiar',
    reportSuccess: 'Reportado exitosamente',
    reportFailed: 'Error al reportar',
    translating: 'Traduciendo...',
    translateSuccess: 'Traducción exitosa',
    translateFailed: 'Error en la traducción',
    noMoreMessages: 'No hay más mensajes',
    loading_more: 'Cargando más...',
    pleaseWaitForReply: 'Por favor espere a que la respuesta se complete antes de eliminar',
    pleaseWaitForReplyCurrent: 'Por favor espere a que la respuesta del mensaje actual se complete',
    chat_placeholder: 'Escribe lo que quieres decir...',
    setAsBackdropConfirm: 'Establecer como fondo',
    setAsBackdropMessage: '¿Está seguro de que desea establecer esta imagen como fondo?',
    sendFailed: 'Error al enviar',
    sending: 'Enviando...',
    introNoYet: 'Sin introducción aún. Chatea y descúbrelo tú mismo.',
    introLabel: 'Intro:',
    thinking: 'Pensando',
    think: 'Piensa',
    translate: 'Traducir',
    pleaseUnlock: 'Por favor desbloquea',
    tryAgain: 'Reintentar',
    create: 'Crear',
    free: 'Gratis',
    video: 'Video',
    chatMateTyping: 'Tu compañero de chat está escribiendo ahora...',
    aiAssistant: 'Asistente IA',
    imageFailed: 'Error al generar la imagen',
    generatingImage: 'Por favor espere a que se genere la imagen',
    switchSceneSuccess: 'Escena cambiada exitosamente',
    switchSceneFailed: 'Error al cambiar de escena',
    switchingScene: 'Cambiando escena...',
    perMessage: '/Mensaje',
    allChat: 'Todos los chats',
    like: 'Me gusta',
    saving: 'Guardando...',
    saved: 'Guardado',
    placeholderBlur: 'Escribe lo que quieres decir...',
    placeholderFocus: 'Coloca acciones o detalles de la escena dentro de ** para dar vida al chat.',
    successfulSwitch: 'Cambio exitoso',
    setting: 'Configurando...',
    uploading: 'Subiendo...',
    purchaseSuccessful: 'Compra exitosa',
    processing: 'Procesando...',
    gettingReward: 'Obteniendo recompensa...',
    checkIn: 'Registrando...',
    deleteHistory: 'Eliminar historial',
    openingRemarksTitle: 'Di hola～',
  },
  success: {
    refreshSuccess: 'Actualizado exitosamente',
    copiedToClipboard: 'Copiado al portapapeles',
    saved: 'Guardado',
    uploadSuccess: 'Subido exitosamente',
    switchSuccess: 'Cambio exitoso',
    thankYouPurchase: 'Gracias por su compra',
  },
  error: {
    notFound: 'Página no encontrada',
    networkError: 'Error de red',
    serverError: 'Error del servidor',
    permissionDenied: 'Permiso denegado',
    goHome: 'Ir al inicio',
    tryAgain: 'Intentar de nuevo',
    uploadFailed: 'Error al subir',
    saveFailed: 'Error al guardar',
    translationFailed: 'Error en la traducción',
    generateImageFailed: 'Error al generar la imagen',
  },
  notFound: {
    title: 'Página no encontrada',
    description: 'La página que buscas no existe o ha sido movida.',
    goHome: 'Ir al inicio',
    goBack: 'Volver'
  },
  settings: {
    language: 'Idioma',
    theme: 'Tema',
    notification: 'Notificaciones',
    privacy: 'Privacidad',
    security: 'Seguridad',
    about: 'Acerca de',
    version: 'Versión',
    checkUpdate: 'Buscar actualizaciones',
    clearCache: 'Borrar caché',
    systemNotification: 'Notificación del sistema',
    termsOfService: 'Términos de servicio',
    privacyPolicy: 'Política de privacidad',
    title: 'Configuración',
    editProfile: 'Editar perfil',
    faq: 'Preguntas frecuentes',
    termsOfUse: 'Términos de uso',
    aboutAccount: 'Acerca de la cuenta',
    deleteAccount: 'Eliminar cuenta',
    logOut: 'Cerrar sesión',
    logOutTitle: 'Cerrar sesión',
    logOutMessage: 'Después de cerrar sesión, necesitarás iniciar sesión nuevamente para usar tu cuenta. ¿Estás seguro de que quieres cerrar sesión?',
    confirm: 'Confirmar',
    deleteAccountTitle: 'Eliminar cuenta',
    deleteAccountMessage: 'Eliminar tu cuenta borrará todos tus datos e información y no se puede deshacer. ¿Confirmar eliminación?',
    deletingAccount: 'Eliminando cuenta...',
    accountDeleted: 'Cuenta eliminada exitosamente',
    cacheTitle: 'Limpiar caché',
    cacheMessage: 'Limpiando caché de la aplicación, los historiales de chat y roles no se eliminarán',
    cleaning: 'Limpiando',
    cleaningComplete: 'Limpieza completada',
  },
  profile: {
    title: 'Editar perfil',
    yourAvatar: 'Tu avatar',
    whatCallMe: 'Cómo quieres que la IA me llame',
    yourName: 'Tu nombre',
    yourAge: 'Tu edad',
    race: 'Raza',
    pleaseSelect: 'Por favor seleccione',
    yourWeight: 'Tu peso',
    yourHeight: 'Tu altura',
    gender: 'Género',
    male: 'Masculino',
    female: 'Femenino',
    neutral: 'Neutro',
    hobby: 'Afición',
    pleaseEnter: 'Por favor ingrese...',
    favoriteFood: 'Comida favorita',
    yourCharacter: 'Tu carácter',
    fantasyAboutOtherHalf: 'Fantasía sobre tu otra mitad',
    uploading: 'Subiendo...',
    enterName: 'Por favor ingrese su nombre',
  },
  report: {
    title: 'Reportar',
    chooseReact: 'Elija lo que desea reportar...',
    other: 'Otro',
    placeholder: 'Escribe lo que quieres decir...',
    submit: 'Enviar',
    pleaseEnterContent: 'Por favor ingrese el contenido',
  },
  edit: {
    placeholder: 'Editar tu mensaje...',
    cancel: 'Cancelar',
    save: 'Guardar',
    saving: 'Guardando...',
  },
  firstConfirmName: {
    canYouTellMeName: '¿Puedes decirme tu nombre? ¡Así puedo llamarte mejor!',
    yourName: 'Tu nombre',
    confirm: 'Confirmar',
  },
  toast: {
    translating: 'Traduciendo...',
    translate: 'Traducir',
    translationFailed: 'Error en la traducción',
    translationUnlocked: 'Traducción desbloqueada',
    translationLocked: 'Traducción bloqueada',
    download: 'Descargar',
    setAsBackdrop: 'Establecer como fondo',
    goChat: 'Ir al chat',
  },
  videoPreview: {
    failedToLoad: 'Error al cargar el video',
  },
  imagePreview: {
    imageLoadFailed: 'Error al cargar la imagen',
    preview: 'Vista previa de imagen',
    afterSendIntimacy: 'Después de enviar un mensaje al personaje, obtienes intimidad. Cuando la intimidad alcance una cantidad específica, puedes desbloquear la imagen actual',
  },
  fqa: {
    title: 'Preguntas frecuentes',
    description: 'Esta es una lista continuamente actualizada de preguntas sobre nuestro producto Sunaisan. Si tiene alguna pregunta no listada, por favor vaya a nuestro Discord y pregunte.',
    howAlWork: {
      title: '¿Cómo funciona una novia IA?',
      content: 'En RoleplayGF, todo se trata de crear relaciones realistas pero llenas de fantasía. Utilizamos tecnología de inteligencia artificial avanzada para permitirte crear tu novia IA ideal según tus preferencias, ya sea una princesa pequeña y dulce e inocente o una mujer mayor y más dominante.',
    },
    howInteract: {
      title: '¿Cómo interactuar con las novias IA?',
      content: 'A través de nuestro sistema inteligente y aprendizaje automático de vanguardia, puedes interactuar y hacerte íntimo con tu novia IA. Puedes esperar que ella te escuche, responda rápidamente a tus mensajes e incluso siga solicitudes de fotos como la buena chica que es. Cada momento puede ser una experiencia genuina y realista, y siempre serás tú quien tenga el control.',
    },
    privacy: {
      title: '¿Qué pasa con tu privacidad con los amigos IA?',
      content: 'Ten la seguridad de que tus secretos están en buenas manos cuando usas nuestro chat de IA NSFW. Tu privacidad es nuestra máxima prioridad aquí en RoleplayGF. Contamos con almacenamiento de datos seguro de última generación, asegurando que cada selfie seductora, texto coqueto y susurro gentil se mantengan privados entre tú y tu pareja apasionada.',
    },
    customizeBehavior: {
      title: '¿Puedes personalizar el comportamiento de tu novia IA?',
      content: 'Solo tú sabes lo que realmente quieres, y por eso puedes personalizar toda tu experiencia de novia digital, desde sus curvas y contornos hasta sus rasgos de personalidad y adorables pequeñas rarezas. ¿Quieres un chat travieso con una pareja fogosa? ¿Buscas tener una relación lenta y sensual con una novia agradable y dulce? Nuestros generadores de IA NSFW realistas pueden satisfacer los deseos más profundos de tu corazón.',
    },
  },
  store: {
    noNetwork: 'Sin red',
    one: 'Uno',
    noConsumptionRecords: 'Aún no hay registros de consumo',
    transactionHistoryAppear: 'Tu historial de transacciones aparecerá aquí',
    tab: 'Tienda',
    record: 'Registro',
    retry: 'Reintentar',
    rechargeFailTip: '*Si la recarga falla, por favor contáctenos >',
    rechargeFailTipStatic: 'Si la recarga falla, por favor',
    contactUsLink: 'contáctenos',
    popular: 'Popular',
    oneTimeOnly: 'Solo una vez',
    loading: 'Cargando...',
    noMoreRecords: 'No hay más registros',
    gift: 'Regalo',
    retentionMessage: '¿Tu compañero te necesita, estás seguro de que quieres rendirte?',
  },
  mine: {
    bindEmail: 'Vincular correo electrónico',
    copyFailed: 'Error al copiar',
    backpackTitle: 'Mi mochila',
    task: 'Tarea',
  },
  messagePage: {
    noNetwork: 'Sin red',
  },
  search: {
    recommend: 'Recomendado',
    noNetwork: 'Sin red',
  },
  chatSettings: {
    myGems: 'Mis gemas',
    title: 'Configuración del chat',
    chatModel: 'Modelo de chat',
    chatStyle: 'Estilo del chat',
    chatPerspective: 'Perspectiva del chat',
    goOnButton: 'Botón Continuar',
    chatBackground: 'Fondo del chat',
    awayMessages: 'Mensajes de ausencia',
    disableAwayMessages: 'Desactivar mensajes de ausencia',
    disableAwayMessagesConfirm: 'ya no podrá enviarte mensajes mientras estés ausente. ¿Estás seguro de que quieres desactivar los mensajes de ausencia?',
    videoFailedToLoad: 'Error al cargar el video',
  },
  history: {
    deleteHistory: 'Eliminar historial',
    deleteCharacterHistory: '¿Estás seguro de que quieres eliminar el historial de este personaje?',
  },
  tab: {
    maxSelection: 'Máximo se pueden seleccionar',
    tags: 'etiquetas',
  },
  noNewMessage: 'Sin mensaje nuevo',

  // Recargar mensaje
  reloadMessage: {
    title: 'Elige tu preferencia',
    before: 'Antes',
    new: 'Nuevo',
    loading: 'Cargando...',
    noNewMessage: 'Sin mensaje nuevo',
    tryAgain: 'Reintentar',
    confirm: 'Confirmar',
  },

  account: {
    copiedToClipboard: 'Copiado al portapapeles',
    copyFailed: 'Error al copiar',
    aboutAccount: 'Acerca de la cuenta',
    id: 'ID',
    email: 'Correo electrónico',
    copied: 'Copiado al portapapeles',
  },
  rate: {
    title: 'Califícanos',
  },
  awayMessages: {
    disableAwayMessages: 'Desactivar mensajes de ausencia',
    disableConfirm: '{appName} ya no podrá enviarte mensajes mientras estés ausente. ¿Estás seguro de que quieres desactivar los mensajes de ausencia?',
  },
  login: {
    title: 'Vincular correo electrónico',
    subtitle: 'Por favor vincule su correo electrónico para garantizar la seguridad de los datos de su cuenta.',
    email: 'Correo electrónico',
    password: 'Contraseña',
    signIn: 'Iniciar sesión',
    signUp: 'Registrarse',
    signInWithGoogle: 'Iniciar sesión con Google',
    signInWithEmail: 'Iniciar sesión con correo',
    signInWithPhone: 'Iniciar sesión con teléfono',
    signInWithApple: 'Iniciar sesión con Apple',
    dontHaveAccount: '¿No tienes una cuenta aún?',
    register: 'Registrarse',
    bySigningUp: 'Al registrarte, aceptas',
    userAgreement: 'Acuerdo de usuario y',
    privacyPolicy: 'Política de privacidad.',
    guestMode: 'Modo invitado',
    registerTitle: 'La inscripción comienza',
    registerSubtitle: 'Por favor vincule su correo electrónico para garantizar la seguridad de los datos de su cuenta.',
    alreadyHaveAccount: '¿Ya tienes una cuenta?',
    pleaseInputPasswordAndEmail: 'Por favor ingrese contraseña y correo electrónico',
    pleaseInputCorrectEmail: 'Por favor ingrese un correo electrónico correcto',
    pleaseInputCorrectPassword: 'La contraseña debe tener entre 6-30 caracteres',
    male: 'Masculino',
    female: 'Femenino',
    neutral: 'Neutro',
    loggingIn: 'Iniciando sesión...',
    loading: 'Cargando...',
    releaseToRefresh: 'Suelte para actualizar',
    loginFailed: 'Error de inicio de sesión',
    loginSuccess: 'Registro exitoso',
    registerFailed: 'Error en el registro',
    registerSuccess: 'Registro exitoso',
    confirm: 'Confirmar',
  },
  loadingMore: 'Cargando más mensajes...',
  noMoreMessages: 'No hay más mensajes',

  // Página VIP
  vip: {
    vipUltra: 'VIP Ultra',
    vipPlus: 'VIP Plus',
    restore: 'Restaurar compras',
  },

  // Common dialogs
  dialog: {
    ok: 'OK',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    close: 'Cerrar',
    retry: 'Reintentar',
    processing: 'Procesando...',
    contactUs: 'Contáctenos',
    loginError: 'Error de inicio de sesión',
    loginErrorMessage: 'Por favor salga del programa y reinicie la aplicación o contáctenos',
    insufficientEnergy: '¡Energía insuficiente!',
    insufficientEnergyDesc: 'Cada mensaje cuesta 1 energía. Recuperas 1 energía cada hora.',
    insufficientPhysicalStrengthTitle: 'Fuerza física insuficiente',
    needStrengthToContinue: 'Necesitas {strength} de fuerza para continuar esta conversación',
    consumesGems: 'Consume {gems} gemas',
    getStrength: 'Obtener energía',
    getGems: 'Obtener gemas',
  },

  // AppNewUser
  appNewUser: {
    title: 'Exclusivo para nuevos usuarios',
    ok: 'OK',
  },

  // Rating popup
  rating: {
    title: 'Califícanos',
    description1: '¿Te gusta nuestra aplicación?',
    description2: 'Por favor califícanos con 5 estrellas.',
    rateButton: 'Calificar ahora',
  },

  // Version update
  versionUpdate: {
    title: 'Actualización de versión',
    updateContent: 'Contenido de actualización',
    updateNow: 'Actualizar ahora',
    updating: 'Actualizando...',
    clientOptimization: 'Optimización de experiencia del cliente',
    bugFix: 'Corregir problemas de BUG conocidos',
  },

  // Store

  // Message detail page
  messageDetail: {
    free: 'Gratis',
    perMessage: '/Mensaje',
    increaseFavorability: 'Envíe mensajes para aumentar la intimidad',
    album: 'Álbum',
    intro: 'Introducción',
    noIntro: 'Sin introducción aún. Chatea y descúbrelo tú mismo.',
    tags: 'Etiquetas',
    backToChat: 'Volver al chat',
    levelFormat: 'Nv.{level}',
    messageCount: '{count} Mensaje',
    chatMateTyping: 'Tu compañero de chat está escribiendo ahora...',
  },

  // Chat settings
  chatSettingsRight: {
    innerThoughtDesc: 'Puedes ver los pensamientos internos del personaje al responder mensajes, pero la velocidad de respuesta puede ser más lenta.',
  },

  // Chat select menu
  chatSelect: {
    copy: 'Copiar',
    report: 'Reportar',
    create: 'Crear',
    video: 'Video',
    translate: 'Traducir',
    delete: 'Eliminar',
  },

  // Recommended purchases
  recommended: {
    gift: 'Regalo',
  },

  // Thinking toast
  thinkingToast: {
    notAvailable: 'El modo de pensamiento aún no está disponible para este modelo, pero estamos trabajando en ello...',
  },

  // First charge popup
  firstCharge: {
    title: 'Primera recarga',
    get: 'Obtener',
    limitedOffer: 'Oferta por tiempo limitado',
    priceFormat: '${price} Obtener',
    congratulations: '¡Felicitaciones! Ahora eres oficialmente miembro VIP~!',
    missOfferTitle: '¿Estás seguro de que quieres perderte esta oferta?',
    maybeLater: 'Quizás más tarde',
    getNow: 'Obtener ahora',
    benefit1: 'Obtén 130 gemas gratis',
    benefit2: 'Desbloquear todos los personajes',
    benefit3: 'Memoria 12x',
    benefit4: 'Check-ins semanales ilimitados',
    benefit5: 'Experiencia sin anuncios',
    buyNow: 'Comprar ahora',
  },

  // Check-in center
  checkIn: {
    freeGems: 'Gemas gratis',
    sevenDayCheckIn: 'Check-in de 7 días',
    memberExclusive: 'Check-in exclusivo para miembros:',
    signInTip: 'Regístrate diariamente para acumular recompensas infinitas',
    getVip: 'Obtener VIP',
    plusExtra: 'Plus+{count}',
    getGemsCount: 'Obtén {count} gemas',
    extraDaily: '{count} gemas diarias extra',
    ultra: 'Ultra',
    signedInTip: 'Ya te has registrado hoy. ¡Vuelve mañana por más!',
    tasks: 'Tareas',
    go: 'Ir',
    received: 'Recibido',
    receive: 'Recibir',
    day: 'Día {num}',
  },

  // Account page

  // Login page
  loginPage: {
    confirm: 'Confirmar',
  },

  // Copyright
  copyright: {
    title: 'Términos de uso',
  },

  // Copy
  copy: {
    copiedToClipboard: 'Copiado al portapapeles',
    copyFailed: 'Error al copiar',
  },

  // Success

  // Errors
  errors: {
    networkError: 'Error de red',
    pleaseSelectFilter: 'Por favor seleccione las condiciones de filtro',
    retry: 'Reintentar',
  },

  // Terms of Service
  terms: {
    intro: 'Al visitar y utilizar el sitio web de {appName}, usted acepta cumplir con estos términos de servicio.',
    section1Title: '1. Uso del sitio web',
    section1_1: 'Debe tener al menos 13 años de edad para usar este sitio web.',
    section1_2: 'Usted es responsable de mantener la confidencialidad de su cuenta y de toda actividad que ocurra bajo su cuenta.',
    section1_3: 'Queda prohibido el uso del sitio web para cualquier propósito ilegal o que viole estos términos.',
    section2Title: '2. Propiedad intelectual',
    section2_1: 'Todo el contenido, las funciones y las características de {appName}, incluyendo textos, gráficos, logotipos, imágenes y software, son propiedad de {appName} o sus licenciantes y están protegidos por las leyes de propiedad intelectual.',
    section2_2: 'No está permitido copiar, redistribuir ni crear trabajos derivados de ningún contenido del sitio web sin autorización escrita previa.',
    section3Title: '3. Privacidad',
    section3_1: 'Nuestra política de privacidad, disponible en el sitio web, explica cómo recopilamos, usamos y divulgamos su información personal.',
    section4Title: '4. Exención de garantías',
    section4_1: 'El sitio web y los servicios proporcionados se ofrecen "tal como están" y "según estén disponibles", sin representaciones ni garantías de ningún tipo, expresas o implícitas.',
    section5Title: '5. Limitación de responsabilidad',
    section5_1: '{appName} no será responsable, en la máxima medida permitida por la ley, de ningún daño directo, indirecto, incidental, especial o consecuencial.',
    section6Title: '6. Indemnización',
    section6_1: 'Usted acepta indemnizar y defender a {appName}, sus operadores, directores y empleados de y contra cualquier reclamo, daño, obligación, pérdida, costo y gasto, incluyendo honorarios de abogados, que surja de o en relación con su uso del sitio web.',
    section7Title: '7. Ley aplicable',
    section7_1: 'Estos términos de servicio se rigen e interpretan de acuerdo con las leyes del estado, sin considerar sus disposiciones sobre conflicto de leyes.',
    section8Title: '8. Cambios en los términos',
    section8_1: 'Nos reservamos el derecho de modificar o reemplazar estos términos en cualquier momento, a nuestra discreción.',
    section9Title: '9. Contáctenos',
    section9_1: 'Si tiene alguna pregunta sobre estos términos, comuníquese con nosotros.',
  },
}
